export class IdLibelleModel {
	id: any;
	libelle: string;
}